import { Query } from 'react-apollo'
import React, { Component } from 'react'
import queryString from 'query-string'

import { ErrorComponent, LoadingComponent, Node } from 'components'

import { query, queryLatest } from './Article.query.js'

import styles from './Article.module.css'

class Article extends Component {
  state = {}

  componentWillMount() {
    const q = queryString.parse(this.props.location.search)

    if (q.visual) {
      this.setState({ visual: q.visual })
    }
  }

  render() {
    return (
      <>
        {!this.props.match.params.latest ? (
          <Query query={query} variables={{ path: this.props.match.url }}>
            {({ loading, error, data }) => {
              if (loading) {
                return <LoadingComponent />
              }
              if (error) {
                return <ErrorComponent message={`Erro! ${error.message}`} />
              }
              if (!data.route) {
                return <ErrorComponent message='Página não encontrada' />
              }

              const entity = data.route.entity

              return (
                <div className={styles.wrapper}>
                  <Node node={entity} visual={this.state.visual} />
                </div>
              )
            }}
          </Query>
        ) : (
          <Query
            query={queryLatest}
            variables={{
              nid: this.props.match.params.slug,
              revision: this.props.match.params.latest === 'latest' ? 'LATEST' : 'DEFAULT',
            }}
          >
            {({ loading, error, data }) => {
              if (loading) {
                return <LoadingComponent />
              }
              if (!loading && error) {
                return <ErrorComponent message={`Erro! ${error.message}`} />
              }
              if (!loading && !data.nodeQuery) {
                return <ErrorComponent message='Página não encontrada' />
              }
              if (!loading && !data.nodeQuery.entities[0]) {
                return <ErrorComponent message='Esse conteúdo não está disponível' />
              }

              const entity = data.nodeQuery.entities[0]

              return (
                <div className={styles.wrapper}>
                  <Node node={entity} visual={this.state.visual} />
                </div>
              )
            }}
          </Query>
        )}
      </>
    )
  }
}

export default Article
